import type { FirebirdConfig } from './types';

const DEFAULT_BASE_URL = 'https://firebirdmusic.app';

let _config: Required<FirebirdConfig> | null = null;

export function setConfig(config: FirebirdConfig): void {
  const baseUrl = (config.baseUrl || DEFAULT_BASE_URL).replace(/\/$/, '');

  try {
    const parsed = new URL(baseUrl);
    if (parsed.protocol !== 'https:' && parsed.protocol !== 'http:') {
      throw new Error('invalid protocol');
    }
  } catch {
    throw new Error(
      `Invalid baseUrl "${baseUrl}". Must be a valid HTTP/HTTPS URL.`
    );
  }

  _config = {
    apiKey: config.apiKey,
    campaignSlug: config.campaignSlug,
    baseUrl
  };
}

export function getConfig(): Required<FirebirdConfig> {
  if (!_config) {
    throw new Error(
      'FirebirdSDK not initialized. Call FirebirdSDK.init() first.'
    );
  }
  return _config;
}
